import filedownloadservice from "./filedownloadservice";

export default {
    downloadReservedMacRangeAsTextFile(startMac, endMac, oui, poolName) {
        let data = "";

        this.getReservedMacAddressList(startMac, endMac, oui, macs => {
            data = macs;
        });

        filedownloadservice.forceFileDownload(data,
            filedownloadservice.getActualDateForFileName() + "_MacAddress_" + poolName + "_Export.txt");
    },

    getReservedMacAddressList(startMac, endMac, oui, macs) {
        let reservedMacAddressRange = "";

        const startMacAsInt = this.convertMacAddressFromStringToInt(startMac);
        const endMacAsInt = this.convertMacAddressFromStringToInt(endMac);

        for (let i = startMacAsInt; i <= endMacAsInt; i++) {
            let mac = this.convertMacAddressFromIntToString(i);

            reservedMacAddressRange += oui + ":" + mac + '\r\n';
        }
        macs(reservedMacAddressRange);
    },
    
    convertMacAddressFromIntToString(macAddress) {
        let macAddressAsInt = parseInt(macAddress);

        if (macAddressAsInt > 16777215 || macAddressAsInt < 0) {
            return "";
        }

        let macAddressAsString = macAddressAsInt.toString(16);

        macAddressAsString = Array(6 - macAddressAsString.length).fill("0").join("") + macAddressAsString;

        let macAddressArray = [];

        for (let i = 0; i < macAddressAsString.length; i += 2) {
            macAddressArray.push(macAddressAsString.substr(i, 2))
        }

        return macAddressArray.join(":").toUpperCase();
    },

    convertMacAddressFromStringToInt(macAddress) {
        let regExp = new RegExp(":", "g");

        let macAddressAsString = macAddress.replace(regExp, '');
        let macAddressAsInt = parseInt("0x" + macAddressAsString);

        if (macAddressAsInt > 16777215 || macAddressAsInt < 0) {
            return;
        }

        return macAddressAsInt;
    },

    isFirstMacAddressGreaterThanOrEqualToSecondMacAddress(firstMacAddress, secondMacAddress) {
        const firstMacAddressAsInt = this.convertMacAddressFromStringToInt(firstMacAddress);
        const secondMacAddressAsInt = this.convertMacAddressFromStringToInt(secondMacAddress);

        return firstMacAddressAsInt >= secondMacAddressAsInt;
    }
}


// WEBPACK FOOTER //
// ./src/services/macaddressservice.js